import { Component, OnInit } from "@angular/core";
import { Http } from '@angular/http';
import { map } from "rxjs/operators";
import { MedicinService } from '../services/index';
import { ApiService } from '../services/api.service';
import { PrerequisiteService } from '../services/prerequisite.service';
import { Router } from "@angular/router";
import { GoogleAnalyticsService } from "../services/google-analytics-service.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-mycards",
  templateUrl: "./mycards.component.html",
  styleUrls: ["./mycards.component.scss"],
  providers: [MedicinService, PrerequisiteService, GoogleAnalyticsService, ApiService]
})
export class MycardsComponent implements OnInit {
  public Group_Number = window.localStorage.getItem("UserGroup");
  sortbyddl: any = false;
  type_list = [];
  mapview: any = false;
  public SampleDiscountCard: boolean = false;
  showcard: any = false;
  public CardsList: any;

  public IsPricesort = true;
  public IsDistancesort = false;
  public distancesort: any;
  //----Sample CardData variable
  public TopText: string = "";
  public HeadingText: string = "";
  //----Card variables
  public SelectedCardPrice: string = "";
  public SelectedCardDrug: string = "";
  public SelectedCardDose: string = "";
  public SelectedCardForm: string = "";
  public SelectPharmacy: string;
  public PharmacyPrice: string;
  public PharmacyContact: string;
  public MemberId: string;
  public RXBin: string;
  public RXCPN: string;
  public HelpLine: string;
  public DialNumber: string;
  public GroupNumber: string;
  public NoDefaultCard: Boolean = false;
  public PAddress1: string = "";
  public PAddress2: string = "";
  public gpid: any;
  public multisource: any;
  public SavedCardList: any = [];
  public unregisterBackButtonAction: any;
  public Quant_Type: string = '';
  public PharmacyPhone: string = "";
  public Card_Quantity: string = "";
  public Card_DrugName: string = "";
  public Card_Dosage: string = "";
  public Card_DrugForm: string = "";
  public PharmacyLat: string = "";
  public PharmacyLng: string = "";
  public SelectedCardId: string = "";
  public PharmacistHelpline: string = "Pharmacist Helpline"
  public PharmacyName: string = "";
  public PAddress3: string = "";
  public UserInputEmail: string = "";
  public PharmacistHL: string = "";
  public SendDiscountMessage = "";
  public DrugResponseType: string = "";
  public DrugMsType: string = "";
  public Card_Pharmacy_Logo: string = "";
  public RXS_Walmart: string = "";
  public RXS_CVS: string = "";
  public Bin: string = "";
  public Pcn: string = "";
  public Plogo: string = "";
  public Card_Type: string = "";
  public Card_Pharmacy_Distance: string = "";
  public Card_CardId: string = "";
  constructor(public apiservice:ApiService, public http: Http, private ms: MedicinService, public rs: PrerequisiteService, public router: Router, private googleAnalyticsService: GoogleAnalyticsService) {
    if (this.rs.GetUserLoggedInStatus() == "signupscreen") {
      this.router.navigate(['/']);
    }
    else {
      this.GetUserCardList();
    }
  }

  ngOnInit() {
    $(document).on('click', '.sortby_ddl ul li', function () {
      $(this).parent().find('li').removeClass('active');
      $(this).addClass('active');
    });
    try {
      $('.navbar ul').css({ 'padding-top': '0px' });
    }
    catch { }
  }
  Showmapview() {
    this.mapview = !this.mapview;
    var header_container = $(".header_container").css("margin-left");
    var header_container_margin = parseInt(header_container);
    if (this.mapview) {
      $("#pharmacy_container").css({
        "max-width": "100%",
        "padding-left": header_container_margin + 15,
        "padding-right": "0"
      });
      $(".pharmacy_list").css("max-width", "424px");
    } else {
      $("#pharmacy_container").removeAttr("style");
      $(".pharmacy_list").removeAttr("style");
    }
  }
  showDiscountcard(item: any) {
    ;
    this.Card_Pharmacy_Logo = "";
    this.RXS_Walmart = "";
    this.Plogo = "";
    this.SelectedCardPrice = item.Price;
    this.SelectedCardDrug = item.DrugName;
    this.SelectedCardDose = item.Dose;
    this.SelectedCardForm = item.Form;
    this.UserInputEmail = null;
    window.localStorage.setItem('SelectedPhamacyId', item.PharmacyId);
    this.UserInputEmail = null;
    this.SendDiscountMessage = "";
    this.PharmacistHelpline = "Pharmacist Helpline"
    this.GroupNumber = item.UserGroup;
    this.PAddress2 = item.Address1 + ", " + item.Address2;
    this.PAddress1 = item.Address1;
    this.PAddress3 = item.Address2;
    this.DrugResponseType = item.PharmacyType;
    this.DrugMsType = item.MultiSouce;
    this.RXBin = item.BIN;
    this.RXCPN = item.PCN;
    this.HelpLine = item.PBMPhone;
    this.DialNumber = this.HelpLine;
    this.Group_Number=item.UserGroup
    // if (item.PharmacyType == "CRX") {
    //   this.RXBin = "015284";
    //   this.RXCPN = "HD";
    //   this.HelpLine = "888-680-0827";
    //   this.DialNumber = "8886800827";
    // }
    // else if (item.PharmacyType == "NVT") {
    //   this.RXBin = "610602";
    //   this.RXCPN = "HD";
    //   this.HelpLine = "866-809-9382";
    //   this.DialNumber = "8668099382";
    // }
    // else if (item.PharmacyType == "RXS") {
    //   this.RXBin = item.BIN;
    //   this.RXCPN = item.PCN;
    //   this.HelpLine = "877-800-7820";
    //   this.DialNumber = "8778007820";
    // }
    // else {
    //   this.RXBin = "600428";
    //   this.RXCPN = "HD";
    //   this.HelpLine = "844-616-9490";
    //   this.DialNumber = "8446169490";
    // }
    this.PharmacyName = item.PharmacyName.replace('at ', '').replace('At ', '');
    if (item.PharmacyName == "use at any major retail pharmacy and save!") {
      this.SelectPharmacy = "For " + item.PharmacyName;
    }
    else {
      this.SelectPharmacy = "" + item.PharmacyName.replace('at ', '').replace('At ', '');
    }
    // if (item.PharmacyType != "RXS" && item.PharmacyName.toLowerCase().indexOf('walmart pharmacy') > -1) {
    //   this.RXBin = "610301";
    //   this.RXCPN = "HD";
    // }
    // if (item.PharmacyType == "RXS") {
    //   if (item.PharmacyName.toLowerCase().indexOf('walmart ') > -1) {
    //     this.RXBin = "610396";
    //     this.RXCPN = "HD";
    //     this.Card_Pharmacy_Logo = item.Plogo;
    //     this.RXS_Walmart = "walmart";
    //     this.Plogo = item.Plogo;
    //   }
    //   else if (item.PharmacyName.toLowerCase().indexOf('cvs pharmacy') > -1) {
    //     this.RXBin = "610301";
    //     this.RXCPN = "HD";
    //     this.Card_Pharmacy_Logo = item.Plogo;
    //     this.RXS_CVS = "cvs";
    //     this.Plogo = item.Plogo;
    //   }
    // }
    this.PharmacyPrice = item.Price;
    this.PharmacyPhone = item.PBMPhone;
    this.Card_Dosage = item.Dose;
    this.Card_DrugName = item.DrugName;
    this.Card_Quantity = item.Quantity;
    this.PharmacyLat = item.Lat;
    this.PharmacyLng = item.Long;
    this.Card_DrugForm = item.Form;
    this.SelectedCardId = item.CardId;
    this.PharmacistHL = this.PharmacyPhone;
    this.Card_Pharmacy_Distance = item.Distance;
    this.Card_CardId = item.CardId;
    this.MemberId = window.localStorage.getItem('UserCharId');
    //  / this.PharmacistHelpline =this.HelpLine;
    if (this.MemberId == null || this.MemberId == undefined || this.MemberId == "" || this.MemberId == "null") {
      this.MemberId = "100-4542";
    }
    this.showcard = true;
  }
  SampleDiscountcard() {
    this.PharmacistHelpline = "844-616-9490";
    this.GroupNumber = window.localStorage.getItem('UserGroup');
    this.MemberId = window.localStorage.getItem('UserCharId');
    this.TopText = "This is your generic card";
    this.HeadingText = "For use at any major retail pharmacy and save!";
    this.RXBin = "";
    this.RXCPN = "";
    this.PAddress2 = "";
    this.PharmacyPhone = "";
    if(this.GroupNumber != null){
      this.Group_Number = this.GroupNumber
    }
    try {
      this.ms.GetDefaultCard(window.localStorage.getItem('WhiteName')).pipe(map(res => res.json()))
        .subscribe(data => {
          if (data.length > 0) {
            if (this.MemberId == null || this.MemberId == undefined || this.MemberId == "" || this.MemberId == "null") {
              this.MemberId = '100-4542';
            }
            this.TopText = data[0].toptext;
            this.HeadingText = data[0].headingtext;
            this.RXBin = data[0].bin;
            this.RXCPN = data[0].pcn;
            this.SampleDiscountCard = true;
          }
          else {
            this.TopText = "This is your generic card";
            this.HeadingText = "For use at any major retail pharmacy and save!";
            this.RXBin = "";
            this.RXCPN = "";
            this.PAddress2 = "";
            this.PharmacyPhone = "";
            this.SampleDiscountCard = true;
          }
        }, error => {
        });
    }
    catch { this.SampleDiscountCard = true; }
  }
  CloseDrugDetails() {
    this.showcard = false;
    this.SampleDiscountCard = false;
  }
  updateCardPrices() {
    debugger;
    this.CardsList = JSON.parse(window.localStorage.getItem('CardListLocally')) || [];
  
    if (!this.CardsList.length) return;
  
    const requests = this.CardsList.map(card =>
      this.apiservice
        .GetLatestPrice(card.npi, card.ndccode, card.zipcode, card.ActualQuantity)
        .pipe(map(res => res.json()))
    );
  
    forkJoin(requests).subscribe(
      (responses) => {
        debugger;
        this.CardsList = this.CardsList.map((card, index) => ({
          ...card,
          Price: `$${responses[index][0].Price}` // Assuming API response is an array and Price is inside the first object
        }));
  debugger;
        window.localStorage.setItem('CardListLocally', JSON.stringify(this.CardsList));
      },
      (error) => {
        console.error('Error fetching prices:', error);
      }
    );
  }
  GetUserCardList() {

    if (this.rs.IsLoginRequired() == "Yes" && (window.localStorage.getItem('UserId') != null && window.localStorage.getItem('UserId') != "" && window.localStorage.getItem('UserId') != undefined) && window.localStorage.getItem('UserId') != "null") {
      try {
        this.ms.GetUserCards(window.localStorage.getItem('UserId')).pipe(map(res => res.json()))
          .subscribe(data => {

            if (data.length > 0) {

              this.CardsList = data;
            }
          }, error => {
          });

      }
      catch { }
    }
    else if (this.rs.IsLoginRequired() == "Yes" && window.localStorage.getItem('SkipSignup') == 'signupskipped') {
      try {
        debugger;
        // this.CardsList = JSON.parse(window.localStorage.getItem('CardListLocally'));
        this.updateCardPrices()
      } catch { }
    }
    else if (this.rs.IsLoginRequired() == "No" && window.localStorage.getItem('UserId') != null && window.localStorage.getItem('UserId') != undefined) {
      try {
        this.ms.GetUserCards(window.localStorage.getItem('UserId')).pipe(map(res => res.json()))
          .subscribe(data => {
            const RemoveDuplicateData = data.reduce((acc, current) => {
              const x = acc.find(item => item.DrugName === current.DrugName && item.Form === current.Form && item.Price === current.Price && item.Dose === current.Dose);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);
            this.CardsList = RemoveDuplicateData;
          });
      } catch { }
    }
    else {
      try {
        debugger;
        // this.CardsList = JSON.parse(window.localStorage.getItem('CardListLocally'));
        this.updateCardPrices()
      } catch { }
    }
  }
  SortcardsList(SortParam: string) {
    this.sortbyddl = false;
    if (SortParam == "Distance") {
      this.CardsList = this.CardsList.sort((a, b) => a.Fdistance <= b.Fdistance ? -1 : 1);
      this.CardsList = this.CardsList.sort((a, b) => a.Fdistance <= b.Fdistance ? -1 : 1);
    }
    else if (SortParam == "Price") {
      this.CardsList = this.CardsList.sort((a, b) => a.Price <= b.Price ? -1 : 1);
      this.CardsList = this.CardsList.sort((a, b) => a.Price <= b.Price ? -1 : 1);
    }
  }
  RedirectGoogleDirection() {
    try {
      let DirectionLink = 'https://www.google.com/maps/dir/?api=1&origin=' + window.localStorage.getItem('UserLat') + ',' + window.localStorage.getItem('UserLong') + '&destination=' + this.PAddress2;
      window.open(DirectionLink, "_blank");
    }
    catch { }
  }
  RemoveCard(Group_Number) {
    if (this.rs.IsLoginRequired() == "Yes") {
      this.ms.RemoveSavedCard(window.localStorage.getItem('UserId'), this.SelectedCardId).pipe(map(res => res.json()))
        .subscribe(data => {
          try {
            this.ms.GetUserCards(window.localStorage.getItem('UserId')).pipe(map(res => res.json()))
              .subscribe(data => {

                if (data.length > 0) {
                  this.CardsList = data;
                  this.RemoveDiscountCard_login(this.SelectedCardId);
                }
                else
                  this.CardsList = [];
              }, error => {
              });
          }
          catch { }
        });
      this.CloseDrugDetails();
    }
    else if (this.rs.IsLoginRequired() == "No" && window.localStorage.getItem('UserId') != null && window.localStorage.getItem('UserId') != undefined) {
      this.ms.RemoveSavedCard(window.localStorage.getItem('UserId'), this.SelectedCardId).pipe(map(res => res.json()))
        .subscribe(data => {
          try {
            this.ms.GetUserCards(window.localStorage.getItem('UserId')).pipe(map(res => res.json()))
              .subscribe(data => {
                if (data.length > 0) {
                  this.CardsList = data;
                  this.RemoveDiscountCard_login(this.SelectedCardId);
                  this.showcard = false;
                }
                else
                  this.CardsList = [];
              }, error => {
              });
          }
          catch { }
        });
      this.CloseDrugDetails();
    }
    else {
      try {
        
        let pid = window.localStorage.getItem('SelectedPhamacyId');
        let Price = this.SelectedCardPrice;
        let SelectedDrugName = this.SelectedCardDrug;
        let DrugDose = this.SelectedCardDose;
        let DrugType = this.SelectedCardForm;
        let userGroup = Group_Number
        let Original_CardList = JSON.parse(window.localStorage.getItem('CardListLocally'));
        let pharmacyname  = this.PharmacyName;
        let paddress1 = this.PAddress1;
        try {
          var result = Original_CardList.filter(function (v) {
            
            return !(v["PharmacyId"] == pid && v["DrugName"] == SelectedDrugName && v["Price"] == Price && v["Dose"] == DrugDose && v["Form"] == DrugType && v["UserGroup"] == userGroup && v["PharmacyName"]==  pharmacyname && v["Address1"] == paddress1);
          });
          window.localStorage.setItem('CardListLocally', JSON.stringify(result))
          let ss = JSON.parse(window.localStorage.getItem('CardListLocally'));
          this.CardsList = JSON.parse(window.localStorage.getItem('CardListLocally'));
          this.showcard = false;
        }
        catch { }
      }
      catch { }
    }
  }
  PharmacyHelpLine() {
    this.PharmacistHelpline = this.HelpLine;
  }
  PrintMe() {
    this.PharmacistHelpline = this.HelpLine;
    setTimeout(() => {
      window.print();
    }, 600);
  }
  ClearMessage(event: any) {
    if (event.target.name == "ShareEmail") {
      this.SendDiscountMessage = "";
      $('.email_field').removeClass('error_msg');
    }
    $('.sendbtn').removeClass('success').text('Send');
  }
  clearClassMsg() {
    $('.email_field').removeClass('error_msg');
    this.SendDiscountMessage = "";
  }
  ShareDiscountCard() {
    $('.email_field').removeClass('error_msg');
    let email_REGEX = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    if (this.ms.IsNullOrEmptyField(this.UserInputEmail) == true) {
      $('.email_field').addClass('error_msg');
      this.SendDiscountMessage = "Email is required";
      return false;
    }
    else if (email_REGEX.test(this.UserInputEmail) == false) {
      $('.email_field').addClass('error_msg');
      this.SendDiscountMessage = "Please enter correct email or valid email";
      return false;
    }
    else {
      let LandingURL = window.location.host;
      $('.loadProcess').addClass('loader');
      $('.loadProcess').css({ 'display': 'block' });
      let ShareCard_Params = this.Card_DrugName + "|" + this.Card_DrugForm + "|" + this.Card_Dosage + "|" + this.Card_Quantity + "|" + this.PharmacyPrice + "|" + this.PharmacyName + "|" + this.PAddress1 + "|" + this.PAddress3 + "|" + this.UserInputEmail;
      //this.googleAnalyticsService.eventEmitter("MyCards Page", "Share Discount Card", ShareCard_Params, 0);commented by shubh
      this.ms.SaveUserShareCard(window.localStorage.getItem('UserId'), this.MemberId, this.Card_DrugName, this.Card_Quantity, this.Card_DrugForm, this.Card_Dosage,
        this.PharmacyPrice, this.PharmacyName, this.PAddress1, this.PAddress3, this.PharmacyPhone, this.RXBin, this.RXCPN, this.GroupNumber,
        this.UserInputEmail, this.PharmacistHL, window.localStorage.getItem('UserLat') + "," + window.localStorage.getItem('UserLong'), LandingURL).pipe(map(res => res.json()))
        .subscribe(data => {
          if (data.length > 0) {
            if (data[0].Status == "Success") {
              $('.loadProcess').css({ 'display': 'none' });
              $('.loadProcess').removeClass('loader');
              this.SendDiscountMessage = "";
              this.UserInputEmail = null;
              $('.sendbtn').addClass('success').text('Success');
            }
            else {
              this.SendDiscountMessage = "Please try after sometime.";
              $('.email_field').addClass('error_msg');
            }
          }
          else {
            this.SendDiscountMessage = "Please try after sometime.";
            $('.email_field').addClass('error_msg');
          }
        });
    }
  }
  ShareDiscountCardGeneric() {
    $('.email_field').removeClass('error_msg');
    let email_REGEX = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    if (this.ms.IsNullOrEmptyField(this.UserInputEmail) == true) {
      $('.email_field').addClass('error_msg');
      this.SendDiscountMessage = "Email is required";
      return false;
    }
    else if (email_REGEX.test(this.UserInputEmail) == false) {
      $('.email_field').addClass('error_msg');
      this.SendDiscountMessage = "Please enter correct email or valid email";
      return false;
    }
    else {
      let LandingURL = window.location.host;
      $('.loadProcess').addClass('loader');
      $('.loadProcess').css({ 'display': 'block' });
      let ShareCard_Params = '' + "|" + '' + "|" + '' + "|" + '' + "|" + '' + "|" + '' + "|" + '' + "|" + '' + "|" + this.UserInputEmail;
      //this.googleAnalyticsService.eventEmitter("MyCards Page", "Share Discount Card", ShareCard_Params, 0);commented by shubh
      this.ms.SaveUserShareCardGeneric(window.localStorage.getItem('UserId'), this.MemberId, '', '', '', '',
        '', '', '', '', '', this.RXBin, this.RXCPN, this.GroupNumber,
        this.UserInputEmail, this.PharmacistHL, window.localStorage.getItem('UserLat') + "," + window.localStorage.getItem('UserLong'), LandingURL).pipe(map(res => res.json()))
        .subscribe(data => {
          if (data.length > 0) {
            if (data[0].Status == "Success") {
              $('.loadProcess').css({ 'display': 'none' });
              $('.loadProcess').removeClass('loader');
              this.SendDiscountMessage = "";
              this.UserInputEmail = null;
              $('.sendbtn').addClass('success').text('Success');
            }
            else {
              this.SendDiscountMessage = "Please try after sometime.";
              $('.email_field').addClass('error_msg');
            }
          }
          else {
            this.SendDiscountMessage = "Please try after sometime.";
            $('.email_field').addClass('error_msg');
          }
        });
    }
  }
  RemoveDiscountCard_login(CardId: string) {
    try {
      let Original_CardList_Login = JSON.parse(window.localStorage.getItem('CardListLocally_Login'));
      let Filter_CardList_Login = Original_CardList_Login.filter((item) => {
        return (item["CardId"] != CardId);
      });
      window.localStorage.setItem('CardListLocally_Login', JSON.stringify(Filter_CardList_Login)
      )
      this.showcard = false;
    }
    catch { }
  }
}
